// Default chart palette injected into every ECharts option when the
// org has no `chart_palette` set in the organizations table. Modern,
// accessible, and works in both light and dark backgrounds.
//
// Per-org overrides (chart_palette TEXT[] column on organizations)
// arrive via the user session in M2/M3 and replace this constant via
// usePalette() — for now M1 ships with this fixed default.

export const DEFAULT_PALETTE: ReadonlyArray<string> = [
  "#4f46e5", // indigo-600
  "#06b6d4", // cyan-500
  "#10b981", // emerald-500
  "#f59e0b", // amber-500
  "#ef4444", // red-500
  "#8b5cf6", // violet-500
  "#ec4899", // pink-500
  "#14b8a6", // teal-500
];
